import React from "react";
import { Button, makeStyles } from "@fluentui/react-components";
import { ReactComponent as GoogleCalendarIcon } from "../icons/Google.svg";
import { ReactComponent as OutlookCalendarIcon } from "../icons/Outlook.svg";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  calendarButtons: {
    display: "flex",
    gap: "8px"
  }
});

const CalendarButtons = ({ googleCalendarUrl, outlookCalendarUrl }) => {
  const styles = useStyles();

  return (
    <div className={styles.calendarButtons}>
      <Button
        as="a"
        href={googleCalendarUrl}
        target="_blank"
        rel="noopener noreferrer"
        icon={<GoogleCalendarIcon />}
        appearance="outline"
      />
      <Button
        as="a"
        href={outlookCalendarUrl}
        target="_blank"
        rel="noopener noreferrer"
        icon={<OutlookCalendarIcon />}
        appearance="outline"
      />
    </div>
  );
};

CalendarButtons.propTypes = {
  googleCalendarUrl: PropTypes.string.isRequired,
  outlookCalendarUrl: PropTypes.string.isRequired
};

export default CalendarButtons;
